// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"CaptionedImage_imageBlock__NWsSq","image":"CaptionedImage_image__ER2wK","caption":"CaptionedImage_caption__FjHsm","photoCredit":"CaptionedImage_photoCredit__CTH1t"};